import RecognitionPrivateComponent from "./RecognitionPrivateComponent";

export default RecognitionPrivateComponent;
